export const SIGNALR_EVENTS = {
  CHAT: {
    NEW_PROJECT_CHAT_MESSAGE_RECEIVED: "NewChatMessageNotification",
    NEW_PROJECT_CHAT_REPLY_RECEIVED: "NewChatMessage",
    NEW_PROJECT_GROUP_CHAT_CREATED: "NewGroupChatCreatedNotification",
    NEW_PORTFOLIO_CHAT_MESSAGE_RECEIVED: "NewPortfolioChatMessageNotification",
    NEW_PORTFOLIO_GROUP_CHAT_CREATED: "NewPortfolioGroupChatCreatedNotification",
    UPDATE_PROJECT_CHAT_UNREAD_COUNT: "UpdateUnreadChatsCount",
    UPDATE_PORTFOLIO_CHAT_UNREAD_COUNT: "UpdateUnreadPortfolioChatsCount",
  },
  COMMUNITY_FEED: {
    NEW_COMMENT: "NewCommentOnMessage",
    NEW_POST: "NewItemOnFeed",
    UPDATE_COMMENT_REACTION_COUNT: "UpdateCommentLikeCount",
    UPDATE_POST_REACTION_COUNT_AND_COMMENT: "UpdateMessageLikeAndCommentsCount",
    NEW_VIDEO_PROCESSED: "VideoProcessed",
  },
};
